// @ts-nocheck

import { createSelector } from 'reselect';

import { selectEntitiesBetslipsEntity } from '../../../../selectors/entities/betslips/entitiesBetslipsPrimary.selector';
import { type SelectorMaker } from '../../../../types/selectors';
import { selectBetslipOptionsByBetslipId } from '../../selectors/betslipOptionsPrimary.selector';

type OptionsSaveItemPropsType = {
  isFavorite?: boolean;
};

const makeBetslipOptionsSaveItemPropsSelector: SelectorMaker<OptionsSaveItemPropsType> = () => {
  return createSelector([selectEntitiesBetslipsEntity, selectBetslipOptionsByBetslipId], (betslip, draftBetslip) => ({
    isFavorite: draftBetslip?.isFavorite ?? betslip?.isFavorite ?? false,
  }));
};

export default makeBetslipOptionsSaveItemPropsSelector;
